import { FileUploadDialog } from 'components/Common/FileUploader/FileUploaderDialog'
import { useHandleDragFiles } from 'components/Common/useHandleDragFiles'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useOrganizationContext } from 'utils/useOrganizationContext'
import { PortalHome } from 'features/AppHome/PortalHome'

const AppPage = () => {
  const navigate = useNavigate()

  const { organizationId } = useOrganizationContext()
  const [newFileUploadActive, setNewFileUploadActive] = useState(false)
  const { handleDragFiles } = useHandleDragFiles((isDragging) =>
    setNewFileUploadActive(isDragging)
  )

  return (
    <>
      <section onDragOver={handleDragFiles}>
        <FileUploadDialog
          isActive={newFileUploadActive}
          setIsActive={setNewFileUploadActive}
          filePostUrl={`api/parties/${organizationId}/projects/import`}
          networkLabel="file-importer"
          onFileUploadSucceed={(data) => {
            setNewFileUploadActive(false)
            navigate(`/app/project/${data}`)
          }}
          onFileUploadFail={() => setNewFileUploadActive(false)}
          allowedExtensions={['.xml','.pdf']}
          allowedExtensionsLabel={['.xml']}
        />
        <PortalHome />
      </section>
    </>
  )
}

export default AppPage
